var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompensation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 4.0625C0.625 3.71732 0.904822 3.4375 1.25 3.4375H13.75C14.0952 3.4375 14.375 3.71732 14.375 4.0625V11.5625C14.375 11.9077 14.0952 12.1875 13.75 12.1875H1.25C0.904822 12.1875 0.625 11.9077 0.625 11.5625V4.0625ZM1.875 7.12499V8.50001C3.09946 8.74856 4.06394 9.71304 4.31249 10.9375H10.6875C10.9361 9.71304 11.9005 8.74856 13.125 8.50001V7.12499C11.9005 6.87644 10.9361 5.91196 10.6875 4.6875H4.31249C4.06394 5.91196 3.09946 6.87644 1.875 7.12499ZM3.01831 4.6875H1.875V5.83081C2.40776 5.64251 2.83001 5.22026 3.01831 4.6875ZM11.9817 4.6875C12.17 5.22026 12.5922 5.64251 13.125 5.83081V4.6875H11.9817ZM13.125 9.79419C12.5922 9.98249 12.17 10.4047 11.9817 10.9375H13.125V9.79419ZM3.01831 10.9375C2.83001 10.4047 2.40776 9.98249 1.875 9.79419V10.9375H3.01831ZM5.3125 7.8125C5.3125 6.54333 6.19003 5.3125 7.5 5.3125C8.80997 5.3125 9.6875 6.54333 9.6875 7.8125C9.6875 9.08167 8.80997 10.3125 7.5 10.3125C6.19003 10.3125 5.3125 9.08167 5.3125 7.8125ZM7.5 6.5625C7.0841 6.5625 6.5625 7.01061 6.5625 7.8125C6.5625 8.61439 7.0841 9.0625 7.5 9.0625C7.9159 9.0625 8.4375 8.61439 8.4375 7.8125C8.4375 7.01061 7.9159 6.5625 7.5 6.5625Z",
    fill: "#062229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensation);
export default __webpack_public_path__ + "static/media/compensation.41743e6b26f4596404056b42ef046197.svg";
export { ForwardRef as ReactComponent };